import React, { useState } from "react";
import "./Details.css";
import { Tabs, Tab, Box, Typography } from "@mui/material";

const EMPTY_EDITOR_HTML = '<div class="ql-editor read-mode"><p><br></p></div>';


const Details = ({ productData, url }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const webLongDescription = productData?.web_long_description?.trim();
  const customTabs = (productData?.tabs || []).filter(
    (tab) => tab?.content?.trim() && tab.content.trim() !== EMPTY_EDITOR_HTML
  );

  // Combine web long description as first tab if it's not just an empty editor div
  const combinedTabs = [
    ...(webLongDescription && webLongDescription !== EMPTY_EDITOR_HTML
      ? [{ label: "Details", content: `<p>${webLongDescription}</p>` }]
      : []),
    ...customTabs,
  ];

  return (
    combinedTabs.length > 0 ? (
      <div className="details">
        {/* Tab Navigation */}
        <div className="details-div">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{}}
          >
            {combinedTabs.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                className={`details-title ${activeTab === index ? "active-tab" : ""}`}
              />
            ))}
          </Tabs>
        </div>
        <div className="details-text">
        </div>

        {/* Tab Content */}
        <Box sx={{ padding: 2 }}>
          {combinedTabs.map((tab, index) => (
            activeTab === index && (
              <div key={index}>
                <div
                  className="tab-content"
                  dangerouslySetInnerHTML={{ __html: tab.content }}
                />
              </div>
            )
          ))}
        </Box>
      </div>
    ) : (
      <div>
        
      </div>
    )
  );
};

export default Details;
